import React from 'react';
import { Grid } from '@mui/material';
import DocumentListVault from '../../document-vault/components/document-list-vault/DocumentListVault';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { EmploymentCategoryContent } from './EmploymentCategoryContent';
import { ProgressOverlay } from '../../../common/progress-overlay/ProgressOverlay';
import { RootState } from '../../../store';

interface DocumentsTabsProps {
  documents: any[];
  key: string;
  cardView?: boolean;
  workflow?: string | null;
  setWorkflow?: React.SetStateAction<any>;
  docsLoading?: string;
  showWorkflowBreadcrumbs?: boolean;
  setShowWorkflowBreadcrumbs?: React.SetStateAction<any>;
}

const DocumentsTabs: React.FC<DocumentsTabsProps> = ({
  documents,
  setWorkflow,
  workflow,
  cardView,
  showWorkflowBreadcrumbs,
  setShowWorkflowBreadcrumbs,
}) => {
  const documentUploadsLoading = useAppSelector((state: RootState) => state.documents.status);

  return (
    <Grid container wrap='nowrap'>
      <Grid size={{ xs: 12 }}>
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <FilterDrawer sections={filterSections} onApplyFilters={handleApplyFilters} />
        </Box> */}
        {cardView ? (
          <EmploymentCategoryContent
            documents={documents}
            workflow={workflow}
            setWorkflow={setWorkflow}
            showWorkflowBreadcrumbs={showWorkflowBreadcrumbs}
            setShowWorkflowBreadcrumbs={setShowWorkflowBreadcrumbs}
          />
        ) : (
          <>
            <DocumentListVault documents={documents} />
            {documentUploadsLoading === 'loading' && (
              <ProgressOverlay className={'position-absolute'} />
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default DocumentsTabs;
